import React, { Dispatch, SetStateAction } from 'react';
import { Win, WinListProps, WinModel } from '../types';
import './WinList.css'
import WinItem from '../WinItem/WinItem';
import WinInputItem from '../WinInputItem';

const WinList: React.FC<WinListProps> = (winListProps) => {

  const wins: WinModel[] = winListProps.wins;
  const displayNewBlankItem: boolean = winListProps.displayNewBlankItem;
  const setDisplayNewBlankItem: Dispatch<SetStateAction<boolean>> = winListProps.setDisplayNewBlankItem;
  const addWinItem: (win: Win) => Promise<void> = winListProps.addWinItem;
  const deleteWinItem: (idToBeRemoved: string) => Promise<void> = winListProps.deleteWinItem;
  const editWinItem: (win: WinModel) => Promise<void> = winListProps.editWinItem;

  return (
    <div>
      <ul className='win-ul'>
        {displayNewBlankItem ? 
        <li className='win-li'>
          <WinInputItem setDisplayNewBlankItem={setDisplayNewBlankItem} addWinItem={addWinItem} />
        </li> : null}
        {wins.map((win) => (
          <li className='win-li'>
            <WinItem win={win} deleteWinItem={deleteWinItem} editWinItem={editWinItem} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WinList;
